export enum AnalyticInputTypeEnum {
  BOOKS = 'books',
  AUTHORS = 'authors',
  STUDY_OBJECT = 'study_object',
  COMPARE_GROUP = 'compare_group',
  READERSHIP_PROFILE = 'readership_profile',
  PRIVATE_READERSHIP_PROFILE = 'private_readership_profile',
}
